import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { useSidebarCollapsed } from "../../hooks/useSidebarCollapsed";

// O header é irmão do <main>, não filho: dentro de <main> o elemento perde o
// papel de landmark banner. A grade o estende sobre as duas colunas, e a
// sidebar nasce na linha de baixo.
function AppShell() {
  const { collapsed, canToggle, toggle } = useSidebarCollapsed();

  return (
    <div className={collapsed ? "shell is-collapsed" : "shell"}>
      <Header />
      <Sidebar collapsed={collapsed} canToggle={canToggle} onToggle={toggle} />
      <main className="content">
        <div className="container">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default AppShell;
